import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {ErrorStateMatcher} from '@angular/material/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Member} from 'src/app/models/member';
import {Report} from 'src/app/models/report';
import {MemberService} from 'src/app/services/member.service';
import {ReportService} from 'src/app/services/report.service';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {CriteriaDialogComponent} from '../criteria-dialog/criteria-dialog.component';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {FileService} from 'src/app/services/file.service';
import {MemberBackgroundService} from 'src/app/services/member-background.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-report-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: [ './report-dialog.component.scss' ]
})
export class ReportDialogComponent implements OnInit {

  public spinner: boolean;
  public isEdit: boolean;
  public report: Report;
  public keyArray: any[] = [];
  public selectedKey: any;
  public selectedKeys: any[] = [];
  public entityForm: FormGroup;
  public dialogRef: any;

  constructor (
    private fb: FormBuilder,
    private _reportService: ReportService,
    private snackBar: SnackBarIconService,
    private _memberService: MemberService,
    private _spinnerService: SpinnerService,
    private dialog: MatDialog,
    private _fileService: FileService,
    public _memberBackgroundService: MemberBackgroundService,
    @Inject(MAT_DIALOG_DATA) public data: Report
  ) {
    this.report = this.data;
    this._reportService.getAnnuities();
    this._reportService.getFormacao();
    this.entityForm = this.createForm();
    this.loadKeys()
  }

  public matcher = new FormErrorStateMatcher();

  ngOnInit () {
    if (this.data.id == "0") {
      this.isEdit = false;
    } else {
      this.isEdit = true;
    }

  }

  loadKeys () {
    this.keyArray = [];

    this.keyArray.push({'name': 'Nome', 'value': 0})
    this.keyArray.push({'name': 'Email', 'value': 1})
    this.keyArray.push({'name': 'Categoria', 'value': 2})
    this.keyArray.push({'name': 'Situação', 'value': 3})
    this.keyArray.push({'name': 'Débito', 'value': 4})
    this.keyArray.push({'name': 'Endereço', 'value': 5})
    this.keyArray.push({'name': 'Número', 'value': 6})
    this.keyArray.push({'name': 'Compl', 'value': 7})
    this.keyArray.push({'name': 'Bairro', 'value': 8})
    this.keyArray.push({'name': 'CEP', 'value': 9})
    this.keyArray.push({'name': 'Cidade', 'value': 10})
    this.keyArray.push({'name': 'Estado', 'value': 11})
    this.keyArray.push({'name': 'Pais', 'value': 12})
    this.keyArray.push({'name': 'Celular', 'value': 13})
    this.keyArray.push({'name': 'RG', 'value': 14})
    this.keyArray.push({'name': 'CPF', 'value': 15})
    this.keyArray.push({'name': 'CRM', 'value': 16})

    this.keyArray.push({'name': 'CRMUF', 'value': 17})
    this.keyArray.push({'name': 'RQE', 'value': 18})

    this.keyArray.push({'name': 'OBS', 'value': 19})

    this.keyArray.push({'name': 'Formação', 'value': 20})
    this.keyArray.push({'name': 'Início', 'value': 21})
    this.keyArray.push({'name': 'Término', 'value': 22})

    this.keyArray.push({'name': 'Vacinado', 'value': 23})
    this.keyArray.push({'name': 'Vigência', 'value': 24})

    this.keyArray.push({'name': 'Gênero', 'value': 25})

    this.keyArray.push({'name': 'Regional', 'value': 26})

    this.keyArray.push({'name': 'Dt Filiação', 'value': 27})
    this.keyArray.push({'name': 'Dt Nasc', 'value': 28})
    this.keyArray.push({'name': 'Dt Título', 'value': 29})
    this.keyArray.push({'name': 'Curriculum Lattes', 'value': 30})
    this.keyArray.push({'name': 'Autoriza Emails', 'value': 31})

    this.keyArray.push({'name': '2010', 'value': 32})
    this.keyArray.push({'name': '2011', 'value': 33})
    this.keyArray.push({'name': '2012', 'value': 34})
    this.keyArray.push({'name': '2013', 'value': 35})
    this.keyArray.push({'name': '2014', 'value': 36})
    this.keyArray.push({'name': '2015', 'value': 37})
    this.keyArray.push({'name': '2016', 'value': 38})
    this.keyArray.push({'name': '2017', 'value': 39})
    this.keyArray.push({'name': '2018', 'value': 40})
    this.keyArray.push({'name': '2019', 'value': 41})
    this.keyArray.push({'name': '2020', 'value': 42})
    this.keyArray.push({'name': '2021', 'value': 43})
    this.keyArray.push({'name': '2022', 'value': 44})
    this.keyArray.push({'name': '2023', 'value': 45})
    this.keyArray.push({'name': '2024', 'value': 46})
    this.keyArray.push({'name': '2025', 'value': 47})
    this.keyArray.push({'name': '2026', 'value': 48})

  }

  add () {
    this.spinner = true;
    const entity = this.createEntity()
    console.log("add: " + JSON.stringify(entity))

    this._reportService.add(entity)
      .then(() => {
        //     console.log(result.id)
        this.snackBar.openSnackBar('Sucesso!', '', 'success');
      })
      .catch((error) => {
        console.log("add report error: " + error.message)
        this.snackBar.openSnackBar('Erro', '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })

  }

  edit () {
    this.spinner = true;
    const entity = this.createEntity()

    this._reportService.edit(entity)
      .then(() => {
        this.snackBar.openSnackBar('Sucesso!', '', 'success');
      })
      .catch((error) => {
        console.log("edit report error: " + error.message)
        this.snackBar.openSnackBar('Erro', '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })

  }

  createForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(this.report.id),
      name: new FormControl(this.report.name, [ Validators.required ]),
    });
    this.selectedKeys = this.report.keys || [];
    return form;
  }

  createEntity () {
    let report: Report;
    if (this.entityForm.valid) {
      report = new Report();
      report.id = this.entityForm.controls.id.value;
      report.name = this.entityForm.controls.name.value;
      report.keys = this.selectedKeys;
    }
    return report;
  }


  addKey () {
    let key = this.keyArray.find((e) => {
      return e.value == this.selectedKey
    })
    if (key) {
      key.criteria = []
      key.criteria.push({
        "id": '99',
        "name": "Todos"
      })
      this.selectedKeys.push(key)
    }
  }

  removeKey (value) {
    this.selectedKeys = this.selectedKeys.filter((e) => {
      return e.value != value
    })
  }

  loadMembers () {
    const waiting = this._spinnerService.show();
    let members: any[] = []
    this._memberService.loadForReports()
      .subscribe((result) => {
        result.forEach(item => {

          if (item.data().name.trim().length > 0 && item.data().deleted !== true) {
            let entity: any = {};
            entity.id = item.id;
            entity.situation = item.data().situation.toString();
            entity.balance = item.data().balance;
            entity.annuity_from = item.data().annuity_from;
            entity.name = item.data().name;
            entity.text = item.data().text;
            entity.image = item.data().image;
            entity.address = item.data().address;
            entity.number = item.data().number;
            entity.complement = item.data().complement;
            entity.district = item.data().district;
            entity.postalCode = item.data().postalCode;
            entity.city = item.data().city;
            entity.state = item.data().state;
            entity.country = item.data().country;
            entity.email = item.data().email;
            entity.email2 = item.data().email2;
            entity.cellPhonePrefix = item.data().cellPhonePrefix;
            entity.cellPhone = item.data().cellPhone;
            entity.faxPhone = item.data().faxPhone;
            entity.clinicPhone = item.data().clinicPhone;
            entity.hospitalPhone = item.data().hospitalPhone;
            entity.aux1Phone = item.data().aux1Phone;
            entity.aux2Phone = item.data().aux2Phone;
            entity.rg = item.data().rg;
            entity.cpf = item.data().cpf;
            entity.crm = item.data().crm;
            entity.crmUF = item.data().crmUF;
            entity.rqe = item.data().rqe;
            entity.dateBirth = item.data().dateBirth;
            entity.dateFiliation = item.data().dateFiliation;
            entity.dateTitle = item.data().dateTitle;
            entity.regional = item.data().regional;
            entity.sex = item.data().sex;
            entity.balance = item.data().balance;
            entity.obs = item.data().obs;
            entity.staff = item.data().staff;
            entity.title = item.data().title;
            entity.created = item.data().created;
            entity.category = item.data().category;
            entity.subCategory = item.data().subCategory;
            entity.tester = item.data().tester ? item.data().tester : false;
            entity.deleted = item.data().deleted;
            entity.zzversion = item.data().zzversion;
            entity.resident_institute = item.data().resident_institute ? item.data().resident_institute : '';
            entity.resident_begin = item.data().resident_begin ? item.data().resident_begin : null;
            entity.resident_end = item.data().resident_end ? item.data().resident_end : null;
            entity.proofOfVaccine = item.data().proofOfVaccine ? true : false;
            entity.linkCurriculum = item.data().linkCurriculum ? item.data().linkCurriculum : '';
            entity.sitePolicySigned = item.data().sitePolicySigned;
            members.push(entity)
          }

        });

        waiting.close();
        this.selectColumns(members)
      })
  }


  selectColumns (members) {
    const waiting = this._spinnerService.show();

    let count: number = 0;
    let membersFiltered = [];

    members.forEach(member => {
      let elected: boolean = false;
      let filtered: any = {}

      for (let key of this.selectedKeys) {
        switch (key.name) {
          case "Nome":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Nome = member.name ? member.name : '';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.name) {
              filtered.Nome = member.name.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.name) {
              filtered.Nome = '-'
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Email":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Email = member.email ? member.email : '';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.email) {
              filtered.Email = member.email.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.email) {
              filtered.Email = '-'
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Categoria":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Categoria = member.subCategory ? member.subCategory.name : '';
              elected = true;
            } else {
              let cat: any;
              if (member.subCategory) { //para a eventualidade de não phaver categoria setada
                cat = key.criteria.find((e) => {
                  return e.id == member.subCategory.id
                })
              }
              if (cat) {
                filtered.Categoria = member.subCategory.name;
                elected = true;
              } else {
                elected = false;
              }
            }
            break;

          case "Situação":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Situação = this.getSituationName(member.situation);
              elected = true;
            } else {
              const cat = key.criteria.find((e) => {
                return e.id == member.situation
              })
              if (cat) {
                filtered.Situation = this.getSituationName(member.situation);
                elected = true;
              } else {
                elected = false;
              }
            }
            break;

          case "Vigência":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Vigência = member.annuity_from;
              elected = true;
            } else {
              const cat = key.criteria.find((e) => {
                return e.id == member.annuity_from
              })
              if (cat) {
                filtered.Situation = member.annuity_from
                elected = true;
              } else {
                elected = false;
              }
            }
            break;

          case "Débito":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Débito = member.balance ? member.balance : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.balance) {
              filtered.Débito = member.balance.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.balance) {
              filtered.Débito = '0';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Endereço":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Endereço = member.address ? member.address : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.address) {
              filtered.Endereço = member.address.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.address) {
              filtered.Endereço = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Número":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Número = member.number ? member.number : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.number) {
              filtered.Número = member.number.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.number) {
              filtered.Número = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Compl":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Compl = member.complement ? member.complement : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.complement) {
              filtered.Compl = member.complement.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.complement) {
              filtered.Compl = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Bairro":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Bairro = member.district ? member.district : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.district) {
              filtered.Bairro = member.district.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.district) {
              filtered.Bairro = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "CEP":
            if (key.criteria[ 0 ].id == '99') {
              filtered.CEP = member.postalCode ? member.postalCode : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.postalCode) {
              filtered.CEP = member.postalCode.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.postalCode) {
              filtered.CEP = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Cidade":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Cidade = member.city ? member.city : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.city) {
              filtered.Cidade = member.city.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.city) {
              filtered.Cidade = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Estado":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Estado = member.state ? member.state : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.state) {
              filtered.Estado = member.state.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.state) {
              filtered.Estado = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Pais":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Pais = member.country ? member.country : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.country) {
              filtered.Pais = member.country.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.country) {
              filtered.Pais = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Celular":
            if (key.criteria[ 0 ].id == '99') {
              let prefix = member.cellPhonePrefix ? member.cellPhonePrefix : '';
              let phone = member.cellPhone ? member.cellPhone : '-';
              filtered.Celular = prefix + " " + phone;
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.cellPhone) {
              let prefix = member.cellPhonePrefix ? member.cellPhonePrefix : '';
              let phone = member.cellPhone ? member.cellPhone : '-';
              filtered.Celular = prefix + " " + phone;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.cellPhone) {
              filtered.Celular = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "RG":
            if (key.criteria[ 0 ].id == '99') {
              filtered.RG = member.rg ? member.rg : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.rg) {
              filtered.RG = member.rg.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.rg) {
              filtered.RG = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "CPF":
            if (key.criteria[ 0 ].id == '99') {
              filtered.CPF = member.cpf ? member.cpf : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.cpf) {
              filtered.CPF = member.cpf.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.cpf) {
              filtered.CPF = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "CRM":
            if (key.criteria[ 0 ].id == '99') {
              filtered.CRM = member.crm ? member.crm : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.crm) {
              filtered.CRM = member.crm.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.crm) {
              filtered.CRM = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "CRMUF":
            if (key.criteria[ 0 ].id == '99') {
              filtered.CRMUF = member.crmUF ? member.crmUF : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.crmUF) {
              filtered.CRMUF = member.crmUF.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.crmUF) {
              filtered.CRMUF = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "RQE":
            if (key.criteria[ 0 ].id == '99') {
              filtered.RQE = member.rqe ? member.rqe : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.rqe) {
              filtered.RQE = member.rqe.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.rqe) {
              filtered.RQE = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;


          case "OBS":
            if (key.criteria[ 0 ].id == '99') {
              filtered.OBS = member.obs ? member.obs : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.obs) {
              filtered.OBS = member.obs.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.obs) {
              filtered.OBS = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Formação":
            const formacaoData = this._reportService.formacao.find((e) => {
              return e.member_id == member.id
            })
            let formacao: string = ""
            if (formacaoData) {
              formacao = `"${ formacaoData.text } • ${ formacaoData.location }"`;
            }
            if (key.criteria[ 0 ].id == '99') {
              filtered.Formação = formacao ? formacao : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && formacao) {
              filtered.Formação = formacao.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !formacao) {
              filtered.Formação = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Início":
            const formacaoDtStart = this._reportService.formacao.find((e) => {
              return e.member_id == member.id
            })

            let formacaoStart: string = "";
            if (formacaoDtStart) {
              formacaoStart = `"${ this.formatDate(formacaoDtStart.dateStart) }"`;
            }

            if (key.criteria[ 0 ].id == '99') {
              filtered.Início = formacaoStart ? formacaoStart : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && formacaoStart) {
              filtered.Início = formacaoStart;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !formacaoStart) {
              filtered.Início = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Término":
            const formacaoDtEnd = this._reportService.formacao.find((e) => {
              return e.member_id == member.id
            })

            let formacaoEnd: string = "";
            if (formacaoDtEnd) {
              formacaoEnd = `"${ this.formatDate(formacaoDtEnd.dateEnd) }"`;
            }
            if (key.criteria[ 0 ].id == '99') {
              filtered.Término = formacaoEnd ? formacaoEnd : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && formacaoEnd) {
              filtered.Término = formacaoEnd;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !formacaoEnd) {
              filtered.Término = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2010":
            let year2010 = this._reportService.annuities_2010.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2010 = year2010 ? year2010.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2010) {
              filtered._2010 = year2010.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2010) {
              filtered._2010 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2011":
            let year2011 = this._reportService.annuities_2011.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2011 = year2011 ? year2011.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2011) {
              filtered._2011 = year2011.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2011) {
              filtered._2011 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2012":
            let year2012 = this._reportService.annuities_2012.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2012 = year2012 ? year2012.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2012) {
              filtered._2012 = year2012.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2012) {
              filtered._2012 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2013":
            let year2013 = this._reportService.annuities_2013.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2013 = year2013 ? year2013.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2013) {
              filtered._2013 = year2013.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2013) {
              filtered._2013 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2014":
            let year2014 = this._reportService.annuities_2014.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2014 = year2014 ? year2014.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2014) {
              filtered._2014 = year2014.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2014) {
              filtered._2014 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2015":
            let year2015 = this._reportService.annuities_2015.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2015 = year2015 ? year2015.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2015) {
              filtered._2015 = year2015.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2015) {
              filtered._2015 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2016":
            let year2016 = this._reportService.annuities_2016.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2016 = year2016 ? year2016.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2016) {
              filtered._2016 = year2016.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2016) {
              filtered._2016 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2017":
            let year2017 = this._reportService.annuities_2017.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2017 = year2017 ? year2017.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2017) {
              filtered._2017 = year2017.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2017) {
              filtered._2017 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2018":
            let year2018 = this._reportService.annuities_2018.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2018 = year2018 ? year2018.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2018) {
              filtered._2018 = year2018.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2018) {
              filtered._2018 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2019":
            let year2019 = this._reportService.annuities_2019.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2019 = year2019 ? year2019.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2019) {
              filtered._2019 = year2019.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2019) {
              filtered._2019 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2020":
            let year2020 = this._reportService.annuities_2020.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2020 = year2020 ? year2020.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2020) {
              filtered._2020 = year2020.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2020) {
              filtered._2020 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2021":
            let year2021 = this._reportService.annuities_2021.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2021 = year2021 ? year2021.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2021) {
              filtered._2021 = year2021.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2021) {
              filtered._2021 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2022":
            let year2022 = this._reportService.annuities_2022.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2022 = year2022 ? year2022.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2022) {
              filtered._2022 = year2022.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2022) {
              filtered._2022 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2023":
            let year2023 = this._reportService.annuities_2023.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2023 = year2023 ? year2023.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2023) {
              filtered._2023 = year2023.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2023) {
              filtered._2023 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2024":
            let year2024 = this._reportService.annuities_2024.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2024 = year2024 ? year2024.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2024) {
              filtered._2024 = year2024.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2024) {
              filtered._2024 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2025":
            let year2025 = this._reportService.annuities_2025.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2025 = year2025 ? year2025.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2025) {
              filtered._2025 = year2025.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2025) {
              filtered._2025 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "2026":
            let year2026 = this._reportService.annuities_2026.find((e) => {
              return e.member_id == member.id
            })
            if (key.criteria[ 0 ].id == '99') {
              filtered._2026 = year2026 ? year2026.value : '0';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && year2026) {
              filtered._2026 = year2026.value;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !year2026) {
              filtered._2026 = "0";
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Vacinado":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Vacina = member.proofOfVaccine ? "Sim" : "Não";
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.proofOfVaccine) {
              filtered.Vacina = "Sim";
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.proofOfVaccine) {
              filtered.Vacina = 'Não'
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Gênero":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Gênero = member.sex ? member.sex : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.sex) {
              filtered.Gênero = member.sex.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.sex) {
              filtered.Gênero = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Regional":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Regional = member.regional ? member.regional : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.regional) {
              filtered.Regional = member.regional.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.regional) {
              filtered.Regional = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Dt Filiação":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Filiação = member.dateFiliation ? this.formatDate(member.dateFiliation) : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.dateFiliation) {
              filtered.Filiação = this.formatDate(member.dateFiliation);
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.dateFiliation) {
              filtered.Filiação = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Dt Nasc":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Nascimento = member.dateBirth ? this.formatDate(member.dateBirth) : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.dateBirth) {
              filtered.Nascimento = this.formatDate(member.dateBirth);
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.dateBirth) {
              filtered.Nascimento = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Dt Título":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Título = member.dateTitle ? this.formatDate(member.dateTitle) : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.dateTitle) {
              filtered.Título = this.formatDate(member.dateTitle);
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.dateTitle) {
              filtered.Título = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Curriculum Lattes":
            if (key.criteria[ 0 ].id == '99') {
              filtered.Curriculum_Lattes = member.linkCurriculum ? member.linkCurriculum : '-';
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && member.linkCurriculum) {
              filtered.Curriculum_Lattes = member.obs.trim();
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !member.linkCurriculum) {
              filtered.Curriculum_Lattes = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

          case "Autoriza Emails":
            const accept = (member.sitePolicySigned && member.sitePolicySigned.acceptEmail) ? "Sim" : 'Não';
            if (key.criteria[ 0 ].id == '99') {
              filtered.Autoriza_Emails = accept;
              elected = true;
            } else if (key.criteria[ 0 ].id == '0' && accept) {
              filtered.Autoriza_Emails = accept;
              elected = true;
            } else if (key.criteria[ 0 ].id == '1' && !accept) {
              filtered.Autoriza_Emails = '-';
              elected = true;
            } else {
              elected = false;
            }
            break;

        }

        if (!elected) {
          break;
        }

      }

      if (elected) {
        membersFiltered.push(filtered);
        count++
      }
    });

    waiting.close()
    this.formatCSV(count, membersFiltered)
  }

  formatCSV (count, members) {
    const waiting = this._spinnerService.show();

    console.log("count: " + count)
    let csvLine: string = '';
    let csvFile: string = '';
    let cellCount: number = 0;
    let cellCountMax: number = Object.entries(members[ 0 ]).length;

    csvLine += this.data.name + " - " + count + " registros\r\n"

    for (let [ key, value ] of Object.entries(members[ 0 ])) {

      csvLine += key
      cellCount++

      if (cellCount < cellCountMax) {
        csvLine += ";"
      } else {
        csvLine += "\r\n";
        cellCount = 0;
      }

    }

    csvFile += csvLine;
    csvLine = '';

    members.forEach(member => {
      for (let [ key, value ] of Object.entries(member)) {

        csvLine += value
        cellCount++

        if (cellCount < cellCountMax) {
          csvLine += ";"
        } else {
          csvLine += "\r\n";
          cellCount = 0;
        }
      }

      csvFile += csvLine;
      csvLine = '';

    });

    //console.log("csvFile: " + csvFile)

    var BOM = "\ufeff";
    let csvData = BOM + csvFile;

    var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});
    this._fileService.saveFile(blob, this.data.name + '.csv');

    waiting.close()

  }

  getSituationName (idx) {
    let situatonName: string = '';
    switch (idx) {
      case "0":
        situatonName = 'Quite';
        break;
      case "1":
        situatonName = 'Não-quite';
        break;
      case "2":
        situatonName = 'Isento';
        break;
    }
    return situatonName
  }

  formatDate (date: any) {
    if (date) {
      let d: any = date
      date = new Date(d.seconds * 1000)
      let dt = date.toISOString()
      let dd: any = dt.substr(8, 2);
      let mm: any = dt.substr(5, 2);
      let yy: any = dt.substr(0, 4);
      return dd + "/" + mm + "/" + yy

    } else {
      return ""
    }
  }


  openDialog (entity) {

    let data: any = {};
    if (entity)
      data = entity;

    this.dialogRef = this.dialog.open(CriteriaDialogComponent, {
      width: '500px',
      height: '385px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        const action: string = response[ 0 ];
        let data: any = response[ 1 ];
        const array: any = response[ 2 ];

        if (action == 'ok') {
          const selection = array.filter((e) => {
            return e.selected == true
          })

          data.criteria = []
          selection.forEach(item => {
            data.criteria.push({
              'id': item.id,
              'name': item.name
            })
          });

          //    console.log("data: " + JSON.stringify(data))

        }
      });

  }


}
